import React, { useState, useEffect } from "react";
import {
  createWorker,
} from "../functions/WorkersQueries";
import { permisos_administracion, permisos_cartera, permisos_comerciales, EXCEPCIONES_PERMISOS } from "../functions/constants";

const DEBUG = false; // Cambia a false para funcionamiento normal
const $debug = DEBUG;

const NuevoTrabajador = ({ setNuevoTrabajador, setRefrescar, clave_organizacion }) => {
  const [data, setData] = useState({
    nombre: "",
    username: "",
    curp: "",
    password: "",
    permiso_3: 0, // Reportes
    permiso_15: 0, // Listado de trabajadores
    permiso_16: 0, // Análisis de cobranza
    permiso_17: 0, // Reporte de colocación
    permiso_20: 0, // Altas
    permiso_21: 0, // Bajas
    permiso_30: 0, // Estados de cuenta
    permiso_33: 0, // Gestión de créditos activos
    permiso_34: 0, // Administración de créditos activos
    permiso_35: 0, // Proyecciones

  });

  // Obtener permisos exceptuados para la organización actual
  const permisosExceptuados = React.useMemo(() => {
    if (!clave_organizacion) return [];
    const excepcion = EXCEPCIONES_PERMISOS.find(ex => ex.clave_organizacion === String(clave_organizacion));
    return excepcion ? excepcion.permisos_no_permitidos : [];
  }, [clave_organizacion]);

  // console.log('clave_organizacion', clave_organizacion);
  // console.log('permisosExceptuados', permisosExceptuados);

  const submitForm = (e) => {
    e.preventDefault();
    const regex = /^(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    if (!regex.test(data.password)) {
      alert(
        "La contraseña debe ser de por lo menos 8 caracteres, y contener al menos una letra mayúscula, una minúscula y un número."
      );
      return;
    }

    // Unificar permisos seleccionados de todos los bloques
    const allPermisos = [
      ...permisos_comerciales,
      ...permisos_cartera,
      ...permisos_administracion,
    ];
    const uniquePermisos = Array.from(new Set(allPermisos.map(p => p.key)));
    const bloques = ["comerciales", "cartera", "administracion"];
    const permisosSeleccionados = {};
    uniquePermisos.forEach(key => {
      // Si el permiso está exceptuado, siempre 0
      if (permisosExceptuados.includes(key)) {
        permisosSeleccionados[key] = 0;
        return;
      }
      const checked = bloques.some(bloque => {
        const checkbox = document.getElementById(`${key}_${bloque}`);
        return checkbox && checkbox.checked;
      });
      permisosSeleccionados[key] = checked ? 1 : 0;
    });

    // Crear objeto final solo con los campos originales y permisos
    let dataFinal = {
      ...data,
      ...permisosSeleccionados,
    };

    // Eliminar todas las propiedades que terminan en _comerciales, _cartera o _administracion
    Object.keys(dataFinal).forEach(key => {
      if (/_comerciales$|_cartera$|_administracion$/.test(key)) {
        delete dataFinal[key];
      }
    });

    if ($debug) {
      console.log("[DEBUG] Datos del formulario:", dataFinal);
      alert("[DEBUG] El formulario está en modo prueba. No se guardará la información.");
      return;
    }
    createWorker(dataFinal, setNuevoTrabajador);
    // createPermissionsNewWorker(dataFinal);
    regresar();
  };

  const seleccionarPermisos = (permisos, bloque) => {
    // Solo seleccionar los que no están exceptuados
    permisos.forEach((permiso) => {
      if (!permisosExceptuados.includes(permiso.key)) {
        const checkbox = document.getElementById(`${permiso.key}_${bloque}`);
        if (checkbox && !checkbox.checked) {
          checkbox.checked = true;
          checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else {
        // Si está exceptuado, asegúrate de que esté desmarcado
        const checkbox = document.getElementById(`${permiso.key}_${bloque}`);
        if (checkbox && checkbox.checked) {
          checkbox.checked = false;
          checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  };

  const regresar = () => {
    setTimeout(() => {
      setRefrescar(1);
    }, 1000);
  };

  const updateField = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  // Disable ignore enter
  useEffect(() => {
    const listener = (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        alert(
          "Asegúrese de llenar los datos marcados con asterisco y después de click en el botón Guardar"
        );
        event.preventDefault();
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, []);

  return (
    <>
      <div className="mt-6 text-xl font-semibold text-center text-sky-700">
        Nuevo Trabajador:
      </div>

      <form method="POST" onSubmit={submitForm}>
        <div className="flex flex-row items-center max-w-full my-2">
          <div className="w-2/5 text-center mx-9">
            <span>Nombre *</span>
          </div>
          <input
            type="text"
            name="nombre"
            id="nombre"
            onChange={updateField}
            required
            className="w-3/5 p-1 mr-3 border rounded border-slate-400"
          />
        </div>

        <div className="flex flex-row items-center max-w-full my-2">
          <div className="w-2/5 text-center mx-9">
            <span>Nombre de usuario *</span>
          </div>
          <input
            type="text"
            name="username"
            id="username"
            onChange={updateField}
            required
            className="w-3/5 p-1 mr-3 border rounded border-slate-400"
          />
        </div>

        <div className="flex flex-row items-center max-w-full my-2">
          <div className="w-2/5 text-center mx-9">
            <span>CURP *</span>
          </div>
          <input
            type="text"
            name="curp"
            id="curp"
            onChange={updateField}
            required
            minLength="18"
            maxLength="18"
            className="w-3/5 p-1 mr-3 border rounded border-slate-400"
          />
        </div>

        <div className="flex flex-row items-center max-w-full my-2">
          <div className="w-2/5 text-center mx-9">
            <span>Contraseña *</span>
          </div>
          <input
            type="password"
            name="password"
            id="password"
            onChange={updateField}
            required
            className="w-3/5 p-1 mr-3 border rounded border-slate-400"
          />
        </div>

        <div className="mt-4 text-center text-sky-700">
          <button
            type="button"
            className="px-3 py-1 mx-4 text-white bg-gray-500 rounded-xl hover:bg-slate-400 hover:text-black hover:duration-500"
            onClick={() => seleccionarPermisos(permisos_comerciales, "comerciales")}
          >
            Seleccionar Permisos Comerciales
          </button>
        </div>
        {permisos_comerciales.map((permiso, idx) => (
          <div
            className={`flex flex-row items-center max-w-full my-2 ${idx % 2 === 0 ? "bg-slate-300" : ""}`}
            key={permiso.key + "_comerciales"}
          >
            <div className="w-2/5 text-center mx-9">
              <span>{permiso.label}</span>
            </div>
            <div className="w-3/5 p-1 mr-3">
              <input
                type="checkbox"
                name={`${permiso.key}_comerciales`}
                id={`${permiso.key}_comerciales`}
                className="w-5 h-5 form-checkbox text-sky-600"
                onChange={updateField}
                disabled={permisosExceptuados.includes(permiso.key)}
              />
            </div>
          </div>
        ))}

        <div className="mt-4 text-center text-sky-700">
          <button
            type="button"
            className="px-3 py-1 mx-4 text-white bg-gray-500 rounded-xl hover:bg-slate-400 hover:text-black hover:duration-500"
            onClick={() => seleccionarPermisos(permisos_cartera, "cartera")}
          >
            Seleccionar Permisos Cartera
          </button>
        </div>
        {permisos_cartera.map((permiso, idx) => (
          <div
            className={`flex flex-row items-center max-w-full my-2 ${idx % 2 === 0 ? "bg-slate-300" : ""}`}
            key={permiso.key + "_cartera"}
          >
            <div className="w-2/5 text-center mx-9">
              <span>{permiso.label}</span>
            </div>
            <div className="w-3/5 p-1 mr-3">
              <input
                type="checkbox"
                name={`${permiso.key}_cartera`}
                id={`${permiso.key}_cartera`}
                className="w-5 h-5 form-checkbox text-sky-600"
                onChange={updateField}
                disabled={permisosExceptuados.includes(permiso.key)}
              />
            </div>
          </div>
        ))}

        <div className="mt-4 text-center text-sky-700">
          <button
            type="button"
            className="px-3 py-1 mx-4 text-white bg-gray-500 rounded-xl hover:bg-slate-400 hover:text-black hover:duration-500"
            onClick={() => seleccionarPermisos(permisos_administracion, "administracion")}
          >
            Seleccionar Permisos Administración
          </button>
        </div>
        {permisos_administracion.map((permiso, idx) => (
          <div
            className={`flex flex-row items-center max-w-full my-2 ${idx % 2 === 0 ? "bg-slate-300" : ""}`}
            key={permiso.key + "_administracion"}
          >
            <div className="w-2/5 text-center mx-9">
              <span>{permiso.label}</span>
            </div>
            <div className="w-3/5 p-1 mr-3">
              <input
                type="checkbox"
                name={`${permiso.key}_administracion`}
                id={`${permiso.key}_administracion`}
                className="w-5 h-5 form-checkbox text-sky-600"
                onChange={updateField}
                disabled={permisosExceptuados.includes(permiso.key)}
              />
            </div>
          </div>
        ))}

        <div className="flex flex-row items-center justify-center mt-4 mb-16">
          <button
            className="px-3 py-1 mx-4 text-white bg-gray-500 rounded-xl hover:bg-slate-400 hover:text-black hover:duration-500"
            onClick={() => setNuevoTrabajador(0)}
          >
            Cancelar
          </button>
          <button
            className="px-3 py-1 mx-4 text-white bg-gray-500 rounded-xl hover:bg-slate-400 hover:text-black hover:duration-500"
            type="submit"
            onKeyPress={submitForm}
          >
            Guardar
          </button>
        </div>
      </form>
    </>
  );
};

export default NuevoTrabajador;
